import { render, staticRenderFns } from "./scratch-card.vue?vue&type=template&id=6c15e15a&"
import script from "./scratch-card.vue?vue&type=script&lang=js&"
export * from "./scratch-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports